export default "__VITE_ASSET__BiBrDDtb__"